/**
 * AutoLayoutIcon — režim rozložení „Auto" v LayoutModeSwitcheru: písmeno A
 * obkroužené dvěma šipkami (automatika = přepíná samo podle viewportu).
 * Oblouky jsou z lucide `RefreshCw`, aby ikona seděla vedle Monitor/Smartphone.
 * Nahrazuje `Sparkles`, která s automatickým layoutem nesouvisela.
 */
import { createLucideIcon } from 'lucide-react';

export const AutoLayoutIcon = createLucideIcon('auto-layout', [
  ['path', { d: 'M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8', key: 'arc1' }],
  ['path', { d: 'M21 3v5h-5', key: 'head1' }],
  ['path', { d: 'M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16', key: 'arc2' }],
  ['path', { d: 'M8 16H3v5', key: 'head2' }],
  ['path', { d: 'm8.5 17 3.5-10 3.5 10', key: 'a-legs' }],
  ['path', { d: 'M9.9 13.5h4.2', key: 'a-bar' }],
]);
